import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { apiService } from "service/ApiService";
import { notify } from "service/NotificationService";

// Components

import Pagination from "components/Pagination/Pagination";

export default function SalesTable({ color }) {
  const [data, setData] = useState([]);
  const [alert, setAlert] = useState(null);

  const [dataPerPage, setDataPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);

  const handleError = (error) => notify("Error", error);

  const fetchData = async () => {
    try {
      const dataResponse = await apiService.get(`api/companies/sales`);
      setData(dataResponse);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAlert(error.message);
      handleError(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const startIndex = currentPage * dataPerPage;
  const paginatedData = data.slice(startIndex, startIndex + dataPerPage);

  return (
    <>
      {alert}
      <div
        className={
          "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
          (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
        }
      >
        <div className="rounded-t mb-0 px-4 py-3 border-0">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full px-4 max-w-full flex-grow flex-1">
              <h3 className={"font-semibold text-lg " + (color === "light" ? "text-blueGray-700" : "text-white")}>Sales Table</h3>
            </div>
          </div>
        </div>
        <div className="block w-full overflow-x-auto">
          {/* Projects table */}
          <table className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Company
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  VAT Number
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Target (€)
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Current (€)
                </th>
                <th
                  className={
                    "px-6 align-middle border border-solid py-3 uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left " +
                    (color === "light"
                      ? "bg-blueGray-50 text-blueGray-500 border-blueGray-100"
                      : "bg-lightBlue-800 text-lightBlue-300 border-lightBlue-700")
                  }
                >
                  Completion
                </th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((sale, index) => (
                <tr key={index}>
                  <th className="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap p-4 text-left flex items-center">
                    <p>{sale.company_name}</p>
                  </th>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap p-4 font-bold">{sale.company_vat}</td>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap p-4">{sale.target_amount}</td>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap p-4">{sale.current_amount}</td>
                  <td className="border-t-0 px-6 align-middle border-l-0 border-r-0 whitespace-nowrap p-4">
                    <div className="flex items-center">
                      <span className="mr-2">{`${((sale.current_amount / sale.target_amount) * 100).toFixed(2)}%`}</span>
                      <div className="relative w-full">
                        <div className="overflow-hidden h-2 text-xs flex rounded bg-red-200">
                          <div
                            style={{ width: `${(sale.current_amount / sale.target_amount) * 100}%` }}
                            className="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-red-500"
                          ></div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <Pagination
          totalRows={data.length}
          dataPerPage={dataPerPage}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setDataPerPage={setDataPerPage}
        />
      </div>
    </>
  );
}

SalesTable.defaultProps = {
  color: "light",
};

SalesTable.propTypes = {
  color: PropTypes.oneOf(["light", "dark"]),
};
